import CookieHelper from './OldCookieHelper';

// dataLayer comes globally from window
class DataLayerHelper {
  setProductDetailToGtm(prodMatchcode, prodPrice, prodTitle) {
    dataLayer.push({
      ecommerce: {
        actionField: { list: `Product Details` },
        currencyCode: CookieHelper.getCurrency(),
        detail: [
          {
            id: prodMatchcode,
            name: prodTitle,
            price: prodPrice,
          },
        ],
      },
    });
  }

  setCheckoutInfoToGtm(gtmStep, gtmProducts) {
    dataLayer.push({
      ecommerce: {
        checkout: {
          actionField: { step: gtmStep },
          products: gtmProducts,
        },
      },
      event: `checkout`,
    });
  }

  setPurchaseInfoToGtm(gtmId, gtmRevenue, gtmTax, gtmShipping, gtmProducts) {
    dataLayer.push({
      ecommerce: {
        currencyCode: CookieHelper.getCurrency(),
        purchase: {
          actionField: {
            afiliation: `RINGANA COM Store`,
            id: gtmId,
            revenue: gtmRevenue,
            shipping: gtmShipping,
            tax: gtmTax,
          },
          products: gtmProducts,
        },
      },
      event: `COM-purchase`,
    });
  }

  setProductInfoOnAddToCartToGtm(atcProducts) {
    dataLayer.push({
      ecommerce: {
        add: {
          products: atcProducts,
        },
        currencyCode: CookieHelper.getCurrency(),
      },
      event: `addToCart`,
    });
  }
}

export default new DataLayerHelper();
